const PATHS: Record<string, string> = {
  wishlist:    'M8 14s-5-3.2-5-7.5A3.5 3.5 0 0 1 8 4a3.5 3.5 0 0 1 5 2.5C13 10.8 8 14 8 14z',
  library:     'M2 3h4v10H2zM7 3h4v10H7zM12 3l1.5 0 1.7 9.7-1.5.3z',
  friends:     'M5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-6 1c-2.2 0-4 1.3-4 3v2h8v-2c0-1.7-1.8-3-4-3zm6 0a4.5 4.5 0 0 0-1.5.25A3.7 3.7 0 0 1 11 11v2h4v-2c0-1.6-1.6-3-4-3z',
  star:        'M8 1l2.2 4.5 4.8.7-3.5 3.4.8 4.8L8 12l-4.3 2.4.8-4.8L1 6.2l4.8-.7z',
  spark:       'M8 1v4M8 11v4M1 8h4M11 8h4M3.5 3.5l2.8 2.8M9.7 9.7l2.8 2.8M3.5 12.5l2.8-2.8M9.7 6.3l2.8-2.8',
  search:      'M11 11l3 3M11 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z',
  plus:        'M8 3v10M3 8h10',
  check:       'M3 8l3 3 7-7',
  refresh:     'M14 8a6 6 0 1 1-1.76-4.24M14 2v3.5h-3.5',
  filter:      'M2 3h12l-4.5 6v4l-3 1.5V9z',
  sort:        'M3 4h10M5 8h6M7 12h2',
  tag:         'M2 3v5.5L7.5 14 14 7.5 8.5 2H3a1 1 0 0 0-1 1zm4 2.5h.01',
  gear:        'M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM8 1l1 2 2 .5 1.5 1.5-.5 2 2 1-2 1 .5 2L11 12.5 9 13l-1 2-1-2-2-.5L3.5 11l.5-2-2-1 2-1-.5-2L5 3.5 7 3z',
  x:           'M3 3l10 10M13 3l-10 10',
  chevron:     'M5 6l3 3 3-3',
  expand:      'M3 6l5 5 5-5',
  collapse:    'M3 10l5-5 5 5',
  controller:  'M4 6h8a3 3 0 0 1 3 3v1a2 2 0 0 1-3.7 1l-1-1.5h-2.6L6.7 11A2 2 0 0 1 3 10V9a3 3 0 0 1 1-3z',
  eye:         'M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4z',
  'eye-off':   'M2 2l12 12M6 6a2 2 0 0 0 4 4M3.5 3.5C2 4.8 1 8 1 8s2.5 5 7 5c1.5 0 2.8-.5 4-1.3M8.5 3c4.3.3 6.5 5 6.5 5s-1 1.5-2.4 2.7',
  logout:      'M6 3H3v10h3M10 5l3 3-3 3M7 8h6',
  menu:        'M2 4h12M2 8h12M2 12h12',
  edit:        'M3 13l1-3L11 3l2 2-7 7-3 1zm7.5-9.5l2 2',
  lightbulb:   'M8 1a5 5 0 0 1 3 9l-1 1H6L5 10a5 5 0 0 1 3-9zm-2 11h4v1.5a2 2 0 0 1-4 0V12z',
  external:    'M9 2h5v5M14 2L7 9M12 9.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3.5',
  bookmark:    'M4 2.5h8v11l-4-3-4 3z',
  grip:        'M6 4h.01M10 4h.01M6 8h.01M10 8h.01M6 12h.01M10 12h.01',
}

interface IconProps {
  name: keyof typeof PATHS
  size?: number
  className?: string
}

export function Icon({ name, size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d={PATHS[name]} />
    </svg>
  )
}
